module.exports = __webpack_public_path__ + "static/media/searchLight.d65e2d6e.svg";